//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Table from '../../components/Table/Table.vue'
import TableCellObject from '../../components/Table/TableCellObject.vue'

export default {
  components: {
    Table,
    TableCellObject
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 0,
        page: 1
      }

    }
  },
  computed: {
    columns: function () {
      let columns = [
        {
          name: 'brigadeName',
          label: 'Бригада',
          align: 'left',
          field: 'brigadeName',
          sortable: false
        },
        {
          name: 'brigadeEmployees',
          label: 'Состав бригады',
          align: 'left',
          field: 'brigadeEmployees',
          sortable: false,
          columnFormat: 'objects',
          columnObjectType: 'employee',
          columnObjectNameProp: ['fio', 'phone']
        },
        {
          name: 'gosNumber',
          label: 'ГРЗ ТС',
          align: 'left',
          field: row => row.gosNumber,
          sortable: false
        },
        {
          name: 'garageNumber',
          label: 'Бортовой номер ТС',
          align: 'left',
          field: row => row.garageNumber,
          sortable: false
        },
        {
          name: 'riStateName',
          label: 'Статус',
          align: 'left',
          field: 'riStateName',
          sortable: false
        },
        {
          name: 'riStateReason',
          label: 'Причина перехода',
          align: 'left',
          field: 'riStateReason',
          sortable: false
        }
      ]
      if (this.mobile) {
        columns = columns.filter(column => column.name === 'brigadeName' || column.name === 'riStateName')
      }
      return columns
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    }
  },
  methods: {
    getTrStyle: function (row) {
      if (row.active === true) {
        return 'background-color: #d3ffd3 !important; border-bottom: solid #e0e0e0 1px;'
      }
    }
  }
}

